import React from 'react';
import { withRouter } from 'react-router';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStore } from 'hooks';
import { PRODUCT_GROUP, VALIDATION } from 'helpers/constants';
import { normalizeProductGroup } from 'helpers/utils';
import { Button, ButtonClose } from 'components/ui/form';
import { Input, Select } from 'components/ui/formik';
import { ProductService } from 'services';
import styles from './product.module.scss';

const GROUP_SHCHEBEN = PRODUCT_GROUP.toString(PRODUCT_GROUP.ONE);

const Product = ({ edit, onClose }) => {
  const { setUser, setLoading } = useStore();

  const initialValues = {
    name: edit ? edit.name : '',
    code: edit ? edit.code : '',
    gng: edit ? edit.gng : '',
    etcis: edit ? edit.etcis : '',
    group: edit ? normalizeProductGroup(edit.group, { emptyValue: GROUP_SHCHEBEN }) : GROUP_SHCHEBEN,
  };

  const onSubmit = async (values) => {
    const productService = new ProductService({ setUser });
    setLoading(true);

    if (edit) {
      await productService.updateProduct(edit.id, { ...values });
    } else {
      await productService.createProduct({ ...values });
    }

    setLoading(false);
    onClose(true);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={
        Yup.object().shape({
          name: Yup.string()
            .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
            .required(...VALIDATION.REQUIRED),
          code: Yup.string()
            .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
            .required(...VALIDATION.REQUIRED),
          gng: Yup.string()
            .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
            .required(...VALIDATION.REQUIRED),
          etcis: Yup.string()
            .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
            .required(...VALIDATION.REQUIRED),
          group: Yup.string()
            .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
            .required(...VALIDATION.REQUIRED),
        })
      }
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.contact} autoComplete="off">
          <div className={styles.main}>
            <div className={styles.title}>
              {`${edit ? 'Редактирование' : 'Добавление'} `}
              продукта
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input label="Название" placeholder="Название" name="name" />
              </div>
              <div className={styles.field}>
                <Input label="Код" placeholder="Код" name="code" />
              </div>
              <div className={styles.field}>
                <Input label="ГНГ" placeholder="ГНГ" name="gng" />
              </div>
              <div className={styles.field}>
                <Input label="ETCIS" placeholder="ETCIS" name="etcis" />
              </div>
              <div className={styles.field}>
                <Select label="Группа" name="group">
                  {PRODUCT_GROUP.list().map(value => (
                    <option
                      value={PRODUCT_GROUP.toString(value)}
                      key={value}
                    >
                      {PRODUCT_GROUP.toString(value)}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className={styles.buttons}>
            <div>
              <Button type="submit">{edit ? 'Редактировать' : 'Добавить'}</Button>
            </div>
            <div>
              <ButtonClose onClick={() => onClose(false)}>{edit ? 'Закрыть' : 'Отменить'}</ButtonClose>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default withRouter(Product);
